// Match patterns like: 'user_profile', 'workspace_xxx.user_profile', 'user_profile[]', 'workspace_xxx.user_profile[]'，'file_attachment[]', 'workspace_xxx.file_attachment[]'
const CUSTOM_TYPE_PATTERN = /\/\/ TODO: failed to parse database type '(?:\w+\.)?(user_profile|file_attachment)(\[\])?'/;

export { CUSTOM_TYPE_PATTERN };

export type ReplacementOutcome = {
  text: string;
  replaced: number;
  unmatched: string[];
};

export function replaceUnknownColumns(source: string): ReplacementOutcome {
  const lines = source.split('\n');
  const result: string[] = [];
  let replaced = 0;
  const unmatched: string[] = [];

  for (let i = 0; i < lines.length; i += 1) {
    const line = lines[i];

    const match = line.match(CUSTOM_TYPE_PATTERN);
    if (match) {
      const typeName = match[1]; // 'user_profile' or 'file_attachment'
      const factory = typeName === 'user_profile' ? 'userProfile' : 'fileAttachment';

      const replacedLine = replaceFollowingUnknown(lines[i + 1], factory);
      if (replacedLine) {
        // Successfully replaced, add the replaced line and skip both the comment and original line
        result.push(replacedLine);
        replaced += 1;
        i += 1; // Skip the next line (original unknown line)
      } else {
        // Failed to replace, keep the comment and continue
        unmatched.push(line.trim());
        result.push(line);
      }
      continue;
    }

    if (line.includes('unknown(')) {
      unmatched.push(line.trim());
    }

    result.push(line);
  }

  return {
    text: result.join('\n'),
    replaced,
    unmatched,
  };
}

export function replaceFollowingUnknown(nextLine: string | undefined, factory: 'userProfile' | 'fileAttachment'): string | undefined {
  if (!nextLine || !nextLine.includes('unknown(')) {
    return undefined;
  }
  // Simply replace 'unknown' with the appropriate factory, preserving everything else (like .array())
  return nextLine.replace('unknown(', `${factory}(`);
}
